<template>
  <div class="sd-list-view">
    <div class="sd-card" v-bind:class="{ loading: loader }">
      <div class="sd-table">
        <div class="sd-table-header">
          <div v-for="(column, index) in tableParams" :key="index"
            @click="!loader ? headerClick(tableParams[index].sortKey) : null"
            class="sd-row-item"
            v-bind:style="{ width: tableParams[index].width }"
          >
            <a>{{ tableParams[index].key }}</a>
            <div v-if="sortKey === tableParams[index].sortKey">
              <img v-if="sortOrder === 'DESC'"
                src="/static/material_icons/expand_less.png"
              />
              <img v-else src="/static/material_icons/expand_more.png"/>
            </div>
          </div>
        </div>
        <!-- renderDate method imported from mixins -->
        <jira-list
          :ticketList="results"
          :renderDate="renderDate"
          :tableParams="tableParams"
        />
      </div>
    </div>
  </div>
</template>

<script>
import mixin from './../mixins/Mixins';

import JiraList from '../../components/JiraList';
import LoaderAnimation from '../../components/LoaderAnimation';

export default {
  name: 'list-view',
  mixins: [mixin],
  props: [
    'loader',
    'results',
  ],

  components: {
    JiraList,
    LoaderAnimation,
  },

  data() {
    return {
      tableParams: [
        {
          key: 'Key',
          sortKey: 'key',
          fields: ['key'],
          renderDate: false,
          clickable: true,
          width: '15%',
        },
        {
          key: 'Summary',
          sortKey: 'summary',
          fields: ['fields', 'summary'],
          renderDate: false,
          clickable: true,
          width: '25%',
        },
        {
          key: 'Status',
          sortKey: 'status',
          fields: ['fields', 'status', 'name'],
          renderDate: false,
          clickable: false,
          defaultValue: 'Nicht definiert',
          width: '20%',
        },
        {
          key: 'Priorität',
          sortKey: 'priority',
          fields: ['fields', 'priority', 'name'],
          renderDate: false,
          clickable: false,
          defaultValue: 'Nicht definiert',
          width: '10%',
        },
        {
          key: 'Assignee',
          sortKey: 'assignee',
          fields: ['fields', 'assignee', 'displayName'],
          renderDate: false,
          clickable: false,
          defaultValue: 'Nicht zugewiesen',
          width: '10%',
        },
        {
          key: 'Created',
          sortKey: 'created',
          fields: ['fields', 'created'],
          renderDate: true,
          clickable: false,
          width: '10%',
        },
        {
          key: 'Updated',
          sortKey: 'updated',
          fields: ['fields', 'updated'],
          renderDate: true,
          clickable: false,
          width: '10%',
        },
      ],
    };
  },

  computed: {
    sortKey() {
      return this.$store.state.filters.sortKey;
    },
    sortOrder() {
      return this.$store.state.filters.sortOrder;
    },
  },

  methods: {
    headerClick(key) {
      this.$store.dispatch('HEADER_CLICK', { key });
      this.$store.dispatch('RESET_SEARCH');
      if (!this.loader) {
        this.$parent.$emit('emitSearch');
      }
    },
  },
};
</script>

<style lang="scss">
@import "./../../Globals.scss";

.sd-list-view {
  max-width: $sd-max-width;
  margin: auto;

  .sd-pagi-wrapper {
    padding: 20px 0 20px 0;
    margin-bottom: 20px;
    position: relative;
    z-index: 0;
  }

  .sd-card {
    transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
    box-shadow: $sd-box-shadow;
    background: #ffffff;
    margin-bottom: 80px;
  }

  .sd-table {
  display: table;
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
    .sd-table-group{
      display: table-row-group;
    }

    .sd-table-header {
      display: table-header-group;
      background-color: $sd-color-blue;
      padding: 5px 10px;
      color: #ffffff;
      font-weight: bold;
      cursor: pointer;
    }

    .sd-table-header,
    .sd-table-row {
      display: table-row;
      width: auto;
      clear: both;
      border: 1px solid #e3e3e3;

      .sd-row-item {
        float: left;
        display: table-column;
        text-align: left;
        padding: 5px 0;

        img {
          height: 15px;
          width: 15px;
        }

        a, span {
          padding: 0 5px;
          float: left;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .clickable {
        text-decoration: none;
        color: $sd-color-blue;
        cursor: pointer;
      }
    }
}

}
</style>


// WEBPACK FOOTER //
// ListView.vue?4c7e6a32